<template>
  <div class='product-introduce-page'>
    <banner :data='banner'></banner>
    <div class='introduce-item introduce-info'>
      <div class='title'>产品介绍</div>
      <p>{{product.introduce}}</p>
    </div>
    <div class='introduce-item strengths'>
      <div class='title'>我们的优势</div>
      <div class='strengths-list'>
        <div v-for='(strength, index) in product.strengths' :key='index' class='strength'>
          <span class='strength-icon'><img :src='strength.image'/></span>
          <div>
            <div class='strength-title'>{{strength.title}}</div>
            <p class='strength-desc'>{{strength.desc}}</p>
          </div>
        </div>
      </div>
    </div>
    <div :class='"introduce-item features " + (product.selfFeatureImage ? "self-feature-image" : "")' v-if='product.features && product.features.length > 0'>
      <div class='title'>产品特点</div>
      <div class='features-list'>
        <div v-for='(feature, index) in product.features' :key='index' class='feature'>
          <div><img :src='feature.image' class='feature-icon'/></div>
          <div>
            <div class='feature-title'>{{feature.title}}</div>
            <p class='feature-desc'>{{feature.desc}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="buttonBox">
      <button class='btn1' v-if='banner.buttonText' @click.stop="banner.buttonCallback">{{banner.buttonText}}</button>
      <button class='btn2' v-if='banner.buttonText1' @click.stop="banner.buttonCallback1">{{banner.buttonText1}}</button>
    </div>
  </div>
</template>

<script>
import Banner from '../components/banner.vue';
import {MEETING_SITE_URL,MEETING_DOWNLOAD_URL} from '../utils/constants';
export default {
  name: 'Introduce',
  components: {
    Banner,
  },
  data() {
    return {
      banner: {
        title: '智慧沟通，触手可及',
        desc: `真实模拟现场会议，一键开始即时会议，<br/>就是这么简单`,
        image: require('../assets/introduce/banner2.png'),
        buttonText: '立即体验',
        buttonCallback: () => {
          window.open(MEETING_SITE_URL);
        },
        buttonText1: '立即下载',
        buttonCallback1: () => {
          window.open(MEETING_DOWNLOAD_URL);
        }
      },
      product: {
        introduce: '全球领先的多媒体通讯平台，用户能够在任何时间、任何地点发起实时通讯，进行大并发的、多方的、实时的音视频互动和数据协同，可用于视频会议、音视频通话、协同办公/设计、远程培训等',
        strengths: [
          {
            title: '码率自适应',
            desc: '实时适应网络情况，多种分辨率切换',
            image: require('../assets/introduce/meeting-image2.png'),
          },
          {
            title: '流畅不卡顿',
            desc: '抗丢包能力强，30%抗丢包无感，70%抗丢包仍可正常通话',
            image: require('../assets/introduce/meeting-image3.png'),
          },
          {
            title: '高并发',
            desc: '支持万人互联不卡顿极低延时',
            image: require('../assets/introduce/meeting-image4.png'),
          },
          {
            title: '高清视频',
            desc: '最高支持1080P高清画质',
            image: require('../assets/introduce/meeting-image1.png'),
          },
          {
            title: '容灾容错',
            desc: '自动重连节点，保证会议不受影响',
            image: require('../assets/introduce/meeting-image5.png'),
          },
        ],
        features: [
          {
            title: '清晰音画，距离咫尺',
            desc: '先进的高清晰音视频技术，高保真还原源内容。语音流畅，视频清晰，顶级回声抑制，真实模拟现场交流环境',
            image: require('../assets/introduce/meeting-image6.png'),
          },
          {
            title: '全终端支持，一键互联',
            desc: '支持全终端会议， 3G/4G/WIFI随时入会，更可通过SIP网关呼叫电话或座机加入到会议中',
            image: require('../assets/introduce/meeting-image11.png'),
          },
          {
            title: '即时注册，随下随用',
            desc: '浏览器/APP/小程序多端支持，简单3步注册，随时开启即时会议，多地协同办公',
            image: require('../assets/introduce/meeting-image7.png'),
          },
          {
            title: '实时共享，全面共享',
            desc: '文档共享，桌面共享，多媒体共享，多方同时画写，犹如现场交流，沟通无障碍',
            image: require('../assets/introduce/meeting-image8.png'),
          },
          {
            title: '高清直播',
            desc: '"会议摇身一变，高清直播上线。扫码即可上线观看，清晰度根据网络自由切换"',
            image: require('../assets/introduce/meeting-image9.png'),
          },
          {
            title: '多种互动方式，模拟最真实现场交流',
            desc: '投票，举手，鼓掌，提问，禁言，文字聊天等多种互动功能，人人可用，操作就是这么简单',
            image: require('../assets/introduce/meeting-image10.png'),
          },
        ],
      },
    }
  },
}
</script>

<style lang="less">
.product-introduce-page {
  .introduce-item {
    .title {
      padding: 40px 0 30px;
      text-align: center;
      font-size: 32px;
      line-height: 45px;
      color: #333333;
      font-weight: 600;
    }
  }
  .introduce-info {
    width: 940px;
    margin-left: auto;
    margin-right: auto;
    font-size: 21px;
    font-weight: 400;
    text-align: center;
    color: #666666;
    line-height: 29px;
    letter-spacing: -1px;
  }
  .strengths {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    .strengths-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .strength {
        width: 50%;
        margin-bottom: 30px;
        display: flex;
        align-items: center;
        .strength-icon {
          width: 100px;
          height: 100px;
          margin-right: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f6f8ff;
          border-radius: 50%;
        }
        >div {
          flex: 1;
        }
        .strength-title {
          font-weight: 600;
          font-size: 24px;
          margin-bottom: 10px;
          color: #333;
        }
        .strength-desc {
          font-size: 18px;
          font-weight: 400;
          color: #666;
        }
      }
    }
  }
  .features {
    margin-top: -30px;
    padding-bottom: 40px;
    &.self-feature-image {
      .feature >div:first-child img {
        height: 340px !important;
      }
    }
    .title {
      width: 1200px;
      margin-left: auto;
      margin-right: auto;
    }
    .features-list {
      .feature {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 40px 0;
        &:nth-of-type(odd) {
          background-color: #f8f6f9;
          flex-direction: row-reverse;
          >div:first-child {
            margin-left: 100px;
          }
        }
        &:nth-of-type(even) {
          background-color: #fff;
          >div:first-child {
            margin-right: 100px;
          }
        }
        >div {
          width: 500px;
          &:first-child {
            text-align: center;
            >img {
              height: 300px;
              max-width: 100%;
            }
          }
        }
        .feature-title {
          font-size: 24px;
          font-weight: 600;
          color: #333333;
          line-height: 33px;
          letter-spacing: -1px;
        }
        .feature-desc {
          font-size: 18px;
          font-weight: 400;
          color: #666666;
          line-height: 25px;
          margin-top: 20px;
        }
      }
    }
  }
}
.buttonBox{
  width: 310px;
  height: 100px;
  margin: 0 auto;
  .btn1,.btn2{
    float: left;
    transition: all 0.3s;
    height: 50px;
    min-width: 140px;
    padding-left: 15px;
    padding-right: 15px;
    background: linear-gradient(325deg,#3b71f2 7%, #8da8ff 95%);
    border-radius: 25px;
    border: none;
    color: #fff;
    cursor: pointer;
    outline: none;
    font-size: 16px;
    &:hover {
      opacity: 0.9;
    }
  }
  .btn2{
    float: left;
    margin-left: 30px;
  }
}
</style>